/* Rquiere de mixin.js */

var ticket = {
	data () {
		return {
			listTickets: [],
			lisTicketMessages: [],
			message: '',
			methods: {
				ticketCreate: 'ticket/register',
				ticketDelete: 'ticket/delete/',
				ticketGet: 'tickets',
				ticketUpdate: 'ticket/update',
				ticketShow: 'ticket/',
				ticketMessagesGet: '/messages',
				ticketMessageCreate: '/message/register',
				ticketMessageDelete: '/message/delete/',
			},
			objectTicket: {
				id: '0',
				subject: '',
				receiverId: 0,
				message: ''
			},
			objectTicketMessage: {
				id: 0,
				message: '',
				ticketId: 0
			},
			paginationListTickets: [],
			searchTickets: ''
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
		addListTickets(newTicket) {
			this.listTickets.unshift(newTicket)
		},
		addListTicketMessage(newTicketMessage) {
			this.lisTicketMessages.push(newTicketMessage)
			console.log(this.$refs.divMessages.scrollBottom)
		},
		clearObjectTicket() {
			this.objectTicket.id = '0'
			this.objectTicket.subject = ''
			this.objectTicket.receiverId = 0
			this.objectTicket.message = ''
		},
		deleteTicket(id) {
			this.$emit('showLockScreen', 'Borrando ticket . . .')
			this.axiosActionIS(this.apiBackend + this.methods.ticketDelete + id, 'DELETE', 'resultDeleteTicket')
		},
		deleteItemListTickets(id) {
			let index = this.listTickets.map((el) => parseInt(el.id)).indexOf(parseInt(id))
			let ticketDeleted = this.listTickets.splice(index,1)
		},
		deleteTicketMessage(id) {
			this.$emit('showLockScreen', 'Borrando mensaje . . .')
			this.axiosActionIS(this.apiBackend + this.methods.ticketShow + this.objectTicket.id + this.methods.ticketMessageDelete + id, 'DELETE', 'resultDeleteTicketMessage')
		},
		deleteItemListTicketMessages(id) {
			let index = this.lisTicketMessages.map((el) => parseInt(el.id)).indexOf(parseInt(id))
			let ticketMessageDeleted = this.lisTicketMessages.splice(index,1)
		},
		getAllTickets(page = 1) {
			this.$emit('showLockScreen', 'Obteniendo lista de Tickets . . .')
			this.axiosActionIS(this.apiBackend + this.methods.ticketGet + '?search=' + this.searchTickets + '&page=' + page, 'GET', 'resultgetAllTickets')
		},
		getAllTicketMessages(idTicket) {
			this.$emit('showLockScreen', 'Obteniendo lista de Mensajes. . .')
			this.axiosActionIS(this.apiBackend + this.methods.ticketShow + idTicket + this.methods.ticketMessagesGet, 'GET', 'resultgetAllTicketMessages')
		},
		saveTicket() {
			let method = (this.objectTicket.id === '0') ? 'POST' : 'PUT'

			this.message.text = ''
			this.$emit('showLockScreen', 'Guardando datos . . .')
			if(method == 'POST') {
				this.axiosActionIS(this.apiBackend + this.methods.ticketCreate, method, 'resultSaveTicketPOST', this.objectTicket)
			} else if(method == 'PUT') {
				this.axiosActionIS(this.apiBackend + this.methods.ticketUpdate, method, 'resultSaveTicketPUT', this.objectTicket)
			}
		},
		saveTicketMessage(id, ticketId, message) {
			if(message.trim() != '') {
				let method = (id === 0) ? 'POST' : 'PUT'
			
				this.objectTicketMessage.id = id
				this.objectTicketMessage.ticketId = ticketId
				this.objectTicketMessage.message = message.trim()	
	
				this.$emit('showLockScreen', 'Guardando comentario . . .')
				if(method == 'POST') {
					this.axiosActionIS(this.apiBackend + this.methods.ticketShow + this.objectTicketMessage.ticketId + this.methods.ticketMessageCreate, method, 'resultSaveTicketMessagePOST', this.objectTicketMessage)
				} else if(method == 'PUT') {
					this.axiosActionIS(this.apiBackend + this.methods.ticketUpdate, method, 'resultSaveTicketMessagePUT', this.objectTicketMessage)
				}
			}
		},
		resultAxiosLocal(responseLocal, response) {
			switch(responseLocal) {
				case 'resultgetAllTickets': this.resultgetAllTickets(response); break;
				case 'resultShowTicketGET': this.resultShowTicketGET(response); break;
				case 'resultDeleteTicket': this.resultDeleteTicket(response); break;
				case 'resultDeleteTicketMessage': this.resultDeleteTicketMessage(response); break;
				case 'resultSaveTicketPOST': this.resultSaveTicket(response, responseLocal); break;
				case 'resultSaveTicketPUT': this.resultSaveTicket(response, responseLocal); break;
				case 'resultgetAllTicketMessages': this.resultgetAllTicketMessages(response); break;
				case 'resultSaveTicketMessagePOST': this.resultSaveTicketMessage(response, responseLocal); break;
				default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
			this.$emit('hideLockScreen')
		},
		resultDeleteTicket(response) {
			if(response.data.success) {
				this.deleteItemListTickets(response.data.data)
				this.socketEmit(['DELETE_TICKET'], response.data.data)
				this.clearObjectTicket()
			}
		},
		resultDeleteTicketMessage(response) {
			if(response.data.success) {
				console.log(response.data.data)
				this.deleteItemListTicketMessages(response.data.data)
				this.socketEmit(['DELETE_TICKET_MESSAGE' + this.objectTicket.id], response.data.data)
			}
		},
		resultgetAllTickets(response) {
			this.listTickets = response.data.data
			this.paginationListTickets = response.data.paginate
		},
		resultSaveTicket(response, responseLocal) {
			if(response.data.success) {
				if(responseLocal == 'resultSaveTicketPOST') {
					this.addListTickets(response.data.data)
					this.socketEmit(['NEW_TICKET'], response.data.data)
				} else if(responseLocal == 'resultSaveTicketPUT') {
					this.updateItemListTickets(response.data.data)
					this.socketEmit(['UPDATE_TICKET'], response.data.data)
				}
				this.clearObjectTicket()
				console.log('Guardado con exito')
			} else {
				this.setErrorSaveTicketLocal(response)
			}
		},
		resultSaveTicketMessage(response, responseLocal) {
			if(response.data.success) {
				if(responseLocal == 'resultSaveTicketMessagePOST') {
					this.addListTicketMessage(response.data.data)
					this.socketEmit(['NEW_TICKET_MESSAGE' + response.data.data.ticket_id], response.data.data)
					this.message = ''
				} else if(responseLocal == 'resultSaveTicketPUT') {
					this.updateItemListTickets(response.data.data)
					this.socketEmit(['UPDATE_TICKET'], response.data.data)
				}
				console.log('Guardado con exito')
			} else {
				this.setErrorSaveTicketLocal(response)
			}
		},
		resultgetAllTicketMessages(response){
			this.resultgetAllTicketMessagesLocal(response)
		},
		resultgetAllTicketMessagesLocal(response) {
			this.lisTicketMessages = response.data.data
			console.log(this.$el)
		},
		setErrorSaveTicketLocal(response) {
			console.groupCollapsed('Error!!! Resultado de consulta axios, funcion por omision (setErrorSaveTicketLocal)')
			console.log(response)
			console.groupEnd()
		},
		setListeningTickets() {
			this.sockets.subscribe('DELETE_TICKET', (data) => { this.deleteItemListTickets(data.body) })
			this.sockets.subscribe('NEW_TICKET', (data) => { this.addListTickets(data.body) })
			this.sockets.subscribe('UPDATE_TICKET', (data) => { this.updateItemListTickets(data.body) })
		},
		setListeningTicketMessages() {
			this.sockets.subscribe('DELETE_TICKET_MESSAGE' + this.objectTicket.id, (data) => { this.deleteItemListTicketMessages(data.body) })
			this.sockets.subscribe('NEW_TICKET_MESSAGE' + this.objectTicket.id, (data) => { this.addListTicketMessage(data.body) })
		},
		setTicketOfListTicket(index, data) {
		},
		showTicket(id) {
			this.axiosActionIS(this.apiBackend + this.methods.ticketShow + id, 'GET', 'resultShowTicketGET', null)
		},
		resultShowTicketGET(response) {
			this.objectTicket = response.data.data
			this.resultShowTicketGETLocal(response)
		},
		resultShowTicketGETLocal(response) {	
		},
		updateItemListTickets(data) {
			let index = this.listTickets.map((el) => el.id).indexOf(data.id)
			this.setTicketOfListTicket(index, data)
		}
	},
};

export default ticket;